import theme from "@styles/theme";

export const CollectionColumn = [
    {
        id: "name",
        label: "Name",
        style: { width: 470, paddingLeft: theme.spacing(6) },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "count",
        label: "Assets Count",
        style: {
            width: 170,
        },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "createdAt",
        label: "Created",
        style: { width: 200 },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "updatedAt",
        label: "Last Updated",
        style: { width: 200 },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

export default CollectionColumn;
